export function getFlyproId(flypro) {
    const id = flypro?.value ?? flypro?.id;
    return id === null || id === undefined || id === '' ? null : String(id);
}

export function getFlyproLabel(flypro) {
    return flypro?.label
        ?? flypro?.extra?.full_name
        ?? [flypro?.firstname, flypro?.lastname].filter(Boolean).join(' ')
        ?? '';
}

function toIdSet(flypros) {
    return new Set((flypros || []).map(getFlyproId).filter(Boolean));
}

export function flyproCoversZip(flypro, zipCode) {
    if (zipCode === null || zipCode === undefined || zipCode === '') {
        return false;
    }

    const numericZip = Number(zipCode);
    return (flypro?.zones || []).some(zone => {
        return String(zone?.zip_code || '')
            .split(',')
            .map(pattern => pattern.trim())
            .filter(Boolean)
            .some(pattern => {
                if (pattern.includes('-')) {
                    const [start, end] = pattern
                        .split('-', 2)
                        .map(value => Number(value.trim()));
                    return Number.isFinite(numericZip)
                        && numericZip >= start
                        && numericZip <= end;
                }

                return pattern === String(zipCode);
            });
    });
}

export function classifySelectedZoneCoverage(selectedFlypros, flyproDetails, zipCode) {
    const detailsById = new Map(
        (flyproDetails || [])
            .map(flypro => [getFlyproId(flypro), flypro])
            .filter(([id]) => Boolean(id))
    );
    const outsideZone = [];
    const unknown = [];

    (selectedFlypros || []).forEach(selected => {
        const details = selected?.zones
            ? selected
            : detailsById.get(getFlyproId(selected));

        if (!details) {
            unknown.push(selected);
        } else if (!flyproCoversZip(details, zipCode)) {
            outsideZone.push(selected);
        }
    });

    return { outsideZone, unknown };
}

export function classifyAdminZoneEligibility(selectedFlypros, normallyEligible, eligibleWithZoneOverride) {
    const normalIds = toIdSet(normallyEligible);
    const overrideIds = toIdSet(eligibleWithZoneOverride);
    const missingFromNormal = (selectedFlypros || []).filter(
        flypro => !normalIds.has(getFlyproId(flypro))
    );

    return {
        outsideZone: missingFromNormal.filter(
            flypro => overrideIds.has(getFlyproId(flypro))
        ),
        invalid: missingFromNormal.filter(
            flypro => !overrideIds.has(getFlyproId(flypro))
        ),
    };
}

export function addAdminZoneOverride(payload, outsideZoneFlypros) {
    return {
        ...payload,
        admin_zone_override: true,
        admin_zone_override_flypro_ids: (outsideZoneFlypros || [])
            .map(getFlyproId)
            .filter(Boolean)
            .map(Number),
        admin_zone_override_reason: 'manual_admin_assignment',
    };
}
